module.exports = __webpack_public_path__ + "static/media/Intramural_Champs.b2eadd65.JPG";